import { FixedBoxTitle } from "pro-features/components/BoxTitle/src/FixedBoxTitle";
import { translate } from "app/filters/i18nFilter";

export const Title = () => {
    return (
        <FixedBoxTitle
            title={translate("market.segmentation.size.growth.bar.char.title")}
            tooltip={translate("market.segmentation.size.growth.bar.char.title.tooltip")}
        />
    );
};
